export interface IEntity {
  id?: number;
  temporaryId: number;
}

//@ts-ignore
export const getIdentifier = (entity: IEntity) =>
  //@ts-ignore
  entity.id !== undefined ? entity.id : entity.temporaryId;
